export default {
  alt: 'Seleccionar idioma',
  en: {
    alt: 'Inglés',
    title: 'Inglés',
  },
  es: {
    alt: 'Español',
    title: 'Español',
  },
  close: {
    alt: 'Cerrar',
  },
  ko: {
    alt: 'Coreano',
    title: 'Coreano',
  },
  zh: {
    alt: 'Chino',
    title: 'Chino',
  },
  vi: {
    alt: 'Vietnamita',
    title: 'Vietnamita',
  },
  ru: {
    alt: 'Ruso',
    title: 'Ruso',
  },
}
